/**
 * OpenDAW engine bootstrap.
 * WASM needs COOP/COEP (set in Vite + Apache). If the SDK is not installed yet,
 * we render a local timeline host so the dashboard still works.
 */
export async function bootEngine(host: HTMLElement): Promise<string> {
  host.innerHTML = "";
  try {
    const wasmMod = await import("@opendaw/studio-core-wasm");
    const sdk = await import("@opendaw/studio-sdk");
    const WasmEngine = (wasmMod as { WasmEngine?: { install?: Function; isEnabled?: Function; ensureReady?: Function } }).WasmEngine;
    if (WasmEngine?.install) {
      WasmEngine.install({
        processorUrl: "/opendaw-wasm/wasm-processor.js",
        offlineWorkerUrl: "/opendaw-wasm/wasm-offline-worker.js",
        wasmUrl: "/opendaw-wasm",
      });
    }
    host.dataset.engine = "opendaw";
    const marker = document.createElement("div");
    marker.className = "status";
    marker.textContent = "OpenDAW studio-sdk loaded. Timeline host ready.";
    host.appendChild(marker);
    drawStubLanes(host);
    void sdk;
    return "opendaw";
  } catch {
    drawStubLanes(host);
    const note = document.createElement("div");
    note.className = "status";
    note.textContent = "OpenDAW SDK not installed yet — showing local timeline host. Run npm install in /studio.";
    host.appendChild(note);
    return "stub";
  }
}

function drawStubLanes(host: HTMLElement) {
  ["Kick", "Bass", "Vocals", "Pad", "Master"].forEach((name, i) => {
    const lane = document.createElement("div");
    lane.className = "lane";
    lane.textContent = name;
    if (i < 4) {
      const clip = document.createElement("div");
      clip.className = "clip";
      clip.style.width = `${28 + i * 10}%`;
      lane.appendChild(clip);
    }
    host.appendChild(lane);
  });
}
